export const baseUrl = process.env.REACT_APP_GATE_WAY_API_URL;
export const baseFileUrl = `${process.env.REACT_APP_GATE_WAY_API_URL}/admin/Files/Images?url=`;
export const storageBaseUrl = process.env.REACT_APP_STORAGE_URL;
export const defaultImage = '/img/default-thumbnail.png';
